import axios from 'axios';

/**
 * 判断是否为登录态失效（区别于业务权限 403）。
 * @param {import('axios').AxiosError} error
 * @returns {boolean}
 */
export function isAuthFailure(error) {
  const status = error.response?.status;
  if (!status || ![401, 403].includes(status)) {
    return false;
  }
  const detail = error.response?.data?.detail;
  const message = typeof detail === 'string' ? detail : '';
  if (message.includes('需要管理员权限') || message.includes('无权访问')) {
    return false;
  }
  if (status === 401) {
    return true;
  }
  return /Token|认证|登录凭证|未提供|SSO/i.test(message);
}

/**
 * 清除本地登录态并跳转本站登录桥。
 */
export function redirectToSsoLogin() {
  const returnTo = encodeURIComponent(
    `${window.location.pathname}${window.location.search}${window.location.hash}` || '/dashboard',
  );
  window.location.href = `/login?return_to=${returnTo}`;
}

/**
 * 为 axios 实例配置本站会话、CSRF 与认证失效处理。
 * @param {import('axios').AxiosInstance} instance
 */
export function attachAuthInterceptors(instance) {
  instance.defaults.withCredentials = true;
  instance.defaults.xsrfCookieName = 'autosquare_relay_csrf';
  instance.defaults.xsrfHeaderName = 'X-CSRFToken';

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.config?.url?.startsWith('/auth/') && isAuthFailure(error)) {
        redirectToSsoLogin();
      }
      return Promise.reject(error);
    },
  );
}

const http = axios.create({
  baseURL: '/api',
  timeout: 30000,
});
attachAuthInterceptors(http);

const adminApi = axios.create({
  baseURL: process.env.VUE_APP_RELAY_API_BASE_URL || '/api/admin',
  timeout: 30000,
});
attachAuthInterceptors(adminApi);

export { http, adminApi };
export default adminApi;
